// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TtbT","left":"styles_left__1KTMj","desktopActions":"styles_desktopActions__Bw-Sn","title":"styles_title__1QFre"};